// extracted by mini-css-extract-plugin
export var active = "DesktopExpandedKeg-module--active--df74a";
export var button = "DesktopExpandedKeg-module--button--56f12";
export var container = "DesktopExpandedKeg-module--container--c7d71";
export var descriptionHeader = "DesktopExpandedKeg-module--descriptionHeader--c991a";
export var desktopSingleExpandedKeg = "DesktopExpandedKeg-module--desktopSingleExpandedKeg--bbc11";
export var earn = "DesktopExpandedKeg-module--earn--93772";
export var expandedKegSubHeader = "DesktopExpandedKeg-module--expandedKegSubHeader--f272d";
export var gatsbyImage = "DesktopExpandedKeg-module--gatsbyImage--c5da1";
export var grow = "DesktopExpandedKeg-module--grow--ca2fe";
export var iconHeaderContainer = "DesktopExpandedKeg-module--iconHeaderContainer--b8290";
export var imageHeader = "DesktopExpandedKeg-module--imageHeader--3fb72";
export var keep = "DesktopExpandedKeg-module--keep--d9727";
export var keepDisclaimer = "DesktopExpandedKeg-module--keepDisclaimer--ce2d8";
export var largeText = "DesktopExpandedKeg-module--largeText--b08aa";
export var largeTextContainer = "DesktopExpandedKeg-module--largeTextContainer--4d12b";
export var leftTab = "DesktopExpandedKeg-module--leftTab--8bc12";
export var leftTabContainer = "DesktopExpandedKeg-module--leftTabContainer--ad031";
export var listItem = "DesktopExpandedKeg-module--listItem--56fb9";
export var mainContent = "DesktopExpandedKeg-module--mainContent--8fd2d";
export var mainImageContainer = "DesktopExpandedKeg-module--mainImageContainer--d9fa8";
export var mainImageDescription = "DesktopExpandedKeg-module--mainImageDescription--6c26a";
export var mainImageDescriptionContainer = "DesktopExpandedKeg-module--mainImageDescriptionContainer--1b277";
export var mainImageDescriptionHeader = "DesktopExpandedKeg-module--mainImageDescriptionHeader--70638";
export var mainImageDescriptionLink = "DesktopExpandedKeg-module--mainImageDescriptionLink--cf73a";
export var rightTab = "DesktopExpandedKeg-module--rightTab--88266";
export var rightTabContainer = "DesktopExpandedKeg-module--rightTabContainer--d094e";
export var subIconContainer = "DesktopExpandedKeg-module--subIconContainer--6a87f";
export var tab = "DesktopExpandedKeg-module--tab--e4b75";